
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { TaskFormData, TaskCategory, TaskType } from "@/types/task";

interface Props {
  formData: TaskFormData;
  setFormData: (data: TaskFormData) => void;
  customType: string;
  setCustomType: (value: string) => void;
  taskTypes: TaskType[];
  categories: TaskCategory[];
}

export const TaskFormDetails = ({ formData, setFormData, customType, setCustomType, taskTypes, categories }: Props) => (
  <>
    <div className="space-y-2">
      <Label htmlFor="priority">الأولوية</Label>
      <Select value={formData.priority} onValueChange={(value: any) => setFormData({ ...formData, priority: value })}>
        <SelectTrigger>
          <SelectValue placeholder="اختر الأولوية" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="low">منخفضة</SelectItem>
          <SelectItem value="medium">متوسطة</SelectItem>
          <SelectItem value="high">عالية</SelectItem>
          <SelectItem value="urgent">عاجلة</SelectItem>
        </SelectContent>
      </Select>
    </div>

    <div className="space-y-2">
      <Label htmlFor="type">نوع المهمة</Label>
      <Select value={formData.type} onValueChange={(value) => setFormData({ ...formData, type: value })}>
        <SelectTrigger>
          <SelectValue placeholder="اختر النوع" />
        </SelectTrigger>
        <SelectContent>
          {taskTypes.map((type) => (
            <SelectItem key={type.id} value={type.id}>
              {type.name}
            </SelectItem>
          ))}
          <SelectItem value="custom">نوع مخصص</SelectItem>
        </SelectContent>
      </Select>
    </div>

    {formData.type === 'custom' && (
      <div className="space-y-2 md:col-span-2">
        <Label htmlFor="customType">النوع المخصص</Label>
        <Input
          id="customType"
          value={customType}
          onChange={(e) => setCustomType(e.target.value)}
          placeholder="أدخل نوع المهمة المخصص"
          required
        />
      </div>
    )}

    {categories.length > 0 && (
      <div className="space-y-2">
        <Label htmlFor="category_id">التصنيف</Label>
        <Select value={formData.category_id} onValueChange={(value) => setFormData({ ...formData, category_id: value })}>
          <SelectTrigger>
            <SelectValue placeholder="اختر التصنيف" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="null">-- بدون تصنيف --</SelectItem>
            {categories.map((category) => (
              <SelectItem key={category.id} value={category.id}>
                {category.name_ar}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    )}
  </>
);
